interface StreamStatusBadgeProps {
  label: string;
  name: string;
  status?: string;
  compact?: boolean;
  /** PTZ 조작이 가능한 카메라인지. 가능한 카메라에만 표시한다 */
  ptz?: boolean;
  /**
   * 배지를 눌렀을 때 할 일. 주면 배지 전체가 버튼이 된다.
   * 이미 크게 보고 있는 화면(1×1)에서는 주지 않는다.
   */
  onClick?: () => void;
}

export function StreamStatusBadge({
  label,
  name,
  status,
  compact,
  ptz,
  onClick,
}: StreamStatusBadgeProps) {
  const isLive = label === "LIVE";

  const content = (
    <>
      <span className="flex items-center gap-1.5">
        {isLive && (
          <span
            className={`shrink-0 rounded-full bg-red-500 animate-pulse ${compact ? "h-2 w-2" : "h-2.5 w-2.5"}`}
          />
        )}
        <span className={isLive ? "text-red-400" : "text-brand"}>{label}</span>
      </span>
      {ptz && (
        <>
          <span className="h-3.5 w-px bg-white/30" />
          {/*
            초록 = 되는 것. 오른쪽 연결 상태 점이 쓰는 색과 같다 — 한 배지 안에서
            색의 뜻이 갈리면 읽는 사람이 매번 다시 해석해야 한다.
          */}
          <span className="shrink-0 text-green-400" title="PTZ 조작 가능">
            PTZ
          </span>
        </>
      )}
      <span className="h-3.5 w-px bg-white/30" />
      <span className="truncate text-white/90">{name}</span>
      {status && (
        <span
          className={`ml-0.5 shrink-0 rounded-full ${compact ? "h-1.5 w-1.5" : "h-2 w-2"} ${
            status === "connected"
              ? "bg-green-400"
              : status === "connecting"
                ? "bg-yellow-400 animate-pulse"
                : "bg-red-400"
          }`}
        />
      )}
    </>
  );

  // 배지 폭은 카메라명이 정한다. `max-w` 로 타일 밖으로 밀려나는 것만 막고,
  // 이름은 `truncate` 로 줄인다 — 3×3·4×4 에서는 아이콘이 늘어 더 좁아진다.
  const className = `absolute top-2 right-2 flex max-w-[calc(100%-1rem)] items-center gap-2 rounded-lg bg-black/70 backdrop-blur-md ${
    compact ? "px-2 py-1 text-[0.625rem]" : "px-3 py-1.5 text-sm"
  } font-bold`;

  if (!onClick) {
    return <div className={className}>{content}</div>;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`${name} 크게 보기`}
      title={`${name} 크게 보기`}
      className={`${className} cursor-pointer transition-colors hover:bg-black/85`}
    >
      {content}
    </button>
  );
}
